'use client';
import React from 'react';
import { useState, useEffect } from 'react';

export default function Select(props) {
  const { register, errors, name, label, required, items, value } = props;
  const [selectedOption, setSelectedOption] = useState(0);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  return (
    <>
      <label
        className="block uppercase tracking-wide  text-xs font-bold mb-2 text-gray-900"
        htmlFor={name}
      >
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <select
        value={selectedOption}
        {...register(`${name}`)}
        onChange={(e) => {
          setSelectedOption(e.target.value);
          props.onChangeHandler && props.onChangeHandler(e.target.value); // Pass the event object if needed by props.onChangeHandler
        }}
        className=" w-full appearance-none block w-full text-xs  text-gray-900 border border-light-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
      >
        {items.map((item, index) => (
          <option key={index} value={item?.id ? item.id : item}>
            {item?.name ? item.name : item}
          </option>
        ))}
      </select>
      {errors[name] && (
        <p className="inputValidation text-xs text-red-800">
          {errors[name].message}
        </p>
      )}
    </>
  );
}
